import { Injectable } from '@angular/core';
import { Platform, NavController, AlertController } from '@ionic/angular';
import { AuthService } from './auth.service';
import { RedatwaterService } from './redatwater.service';
import { TextSpeechService } from './text-speech.service';
import { TranslateConfigService } from './translate-config.service';
import { Browser } from '@capacitor/browser';

@Injectable({
  providedIn: 'root'
})
export class AquabotService {

  enProceso: boolean = false;
  contadorReintentos: number = 0;
  maxReintentos: number = 5;
  intervaloReintento: number = 16000;

  msgAquaBot: any = {
    guia_referencia: '',
    msg: '',
    estado: '',
    estado_animado: '',
    objeto_animado: {
      cabeza: '',
      ojos: 'eye-casual',
      ojos_pupila: 'pupil-casual',
      boca: 'mouth-casual',
      cuerpo: 'body-casual',
      nucleo: 'energy',
      brazos: {
        der: 'limb-left-casual',
        izq: 'limb-right-casual'
      }
    }
  };

  entoronoAnimacion: any = {
    entorno_dia: {
      fondo: 'entorno_dia',
      tipo_animacion: 'casual',
      objetos: {
        sol: 'sun',
        luna: 'moon',
        arbol: 'tree',
        cielo: 'headerEntorno',
        estrellas: 'star',
        nubes: 'cloud',
        zepelin: 'zepelinEntornoDia',
        contenido: 'contenidoEntorno',
        suelo: 'footerEntorno'
      }
    },
    entorno_tarde: {
      fondo: 'entorno_dia_tarde',
      tipo_animacion: 'casual',
      objetos: {
        sol: 'sun',
        luna: 'moon',
        arbol: 'tree',
        cielo: 'headerEntorno',
        estrellas: 'star',
        nubes: 'cloud',
        zepelin: 'zepelinEntornoDia',
        contenido: 'contenidoEntorno',
        suelo: 'footerEntorno'
      }
    },
    entorno_noche: {
      fondo: 'entorno_noche',
      tipo_animacion: 'casual',
      objetos: {
        luna: 'moon',
        sol: 'sun',
        arbol: 'tree',
        cielo: 'headerEntorno',
        nubes: 'cloud',
        estrellas: 'star',
        contenido: 'contenidoEntorno',
        suelo: 'footerEntorno'
      }
    },
    entorno_agua: {
      fondo: 'entorno_agua',
      tipo_animacion: 'casual',
      objetos: {
        pez_1: 'fish',
        pez_2: 'second-fish',
        pez_3: 'third-fish',
        cielo: 'headerEntorno',
        contenido: 'contenidoEntorno',
        algas: 'algae',
        suelo_algas: 'seaweed',
        suelo: 'footerEntorno'
      },

    },
    entorno_oficina: {
      fondo: 'entorno_oficina',
      tipo_animacion: 'casual',
      objetos: {
        reloj: 'clock',
        planta: 'plant',
        pintura: 'painting',
        cielo: 'headerEntorno',
        contenido: 'contenidoEntorno',
        suelo: 'footerEntorno'
      }
    }
  }


  estadosAnimacion = { // BACKUP DE ANIMACIONES 
    hablando: {
      cabeza: '',
      ojos: 'eye-casual',
      ojos_pupila: 'pupil-casual',
      boca: 'mouth',
      cuerpo: 'body-casual',
      nucleo: 'energy',
      brazos: {
        der: 'limb-left-casual',
        izq: 'limb-right-casual'
      }
    },
    hablando_full: {
      cabeza: '',
      ojos: 'eye-casual',
      ojos_pupila: 'pupil',
      boca: 'mouth',
      cuerpo: 'body',
      nucleo: 'energy',
      brazos: {
        der: 'limb-left',
        izq: 'limb-right'
      }
    },
    casual: {
      cabeza: '',
      ojos: 'eye-casual',
      ojos_pupila: 'pupil-casual',
      boca: 'mouth-casual',
      cuerpo: 'body-casual',
      nucleo: 'energy',
      brazos: {
        der: 'limb-left',
        izq: 'limb-right-casual'
      }
    },
    casual_1: {
      cabeza: '',
      ojos: 'eye',
      ojos_pupila: 'pupil',
      boca: 'mouth-casual',
      cuerpo: 'body',
      nucleo: 'energy',
      brazos: {
        der: 'limb-left',
        izq: 'limb-right-casual'
      }
    },
    casual_2: {
      cabeza: '',
      ojos: 'eye-casual',
      ojos_pupila: 'pupil-casual',
      boca: 'mouth-casual',
      cuerpo: 'body-casual',
      nucleo: 'energy',
      brazos: {
        der: 'limb-left',
        izq: 'limb-right'
      }
    },
    casual_ok: {
      cabeza: '',
      ojos: 'eye-casual',
      ojos_pupila: 'pupil-casual',
      boca: 'mouth-casual',
      cuerpo: 'body-ok',
      nucleo: 'energy-ok',
      brazos: {
        der: 'limb-left',
        izq: 'limb-right-casual'
      }
    },
    casual_ok_hablando: {
      cabeza: '',
      ojos: 'eye-casual',
      ojos_pupila: 'pupil-casual',
      boca: 'mouth',
      cuerpo: 'body-ok',
      nucleo: 'energy-ok',
      brazos: {
        der: 'limb-left',
        izq: 'limb-right-casual'
      }
    },
    error_hablando: {
      cabeza: '',
      ojos: 'eye-casual',
      ojos_pupila: 'pupil-casual',
      boca: 'mouth',
      cuerpo: 'body-error',
      nucleo: 'energy-error',
      brazos: {
        der: 'limb-left-error',
        izq: 'limb-right-error'
      }
    },
    error_casual: {
      cabeza: '',
      ojos: 'eye-casual',
      ojos_pupila: 'pupil-casual',
      boca: 'mouth-casual',
      cuerpo: 'body-error',
      nucleo: 'energy-error',
      brazos: {
        der: 'limb-left-error',
        izq: 'limb-right'
      }
    }
  };

  constructor(
    private platform: Platform,
    private alertCtr: AlertController,
    private navCtrl: NavController,
    private translateConfigService: TranslateConfigService,
    private textSpeech: TextSpeechService,
    private redatwater: RedatwaterService,
    private auth: AuthService,
  ) {
    //console.log('Service -> AquaBot');
    //console.log('Iniciando.... AQUABOT');
    this.iniciarCicloAquabot();

  }

  appMsgAquaBot(msg: any): any {
    if (msg) {
     // console.log('Seguimiento -> Msg: ', msg);
      this.setMsgAquaBot(msg);
      return msg;
    }
  }

  setMsgAquaBot(msg: any) {
    if (msg) {
      //console.log('Seguimiento -> Msg: ', msg);
      this.msgAquaBot = msg;
    }
  }

  getAquaBot() {
    return this.msgAquaBot;
  }


  getEstadosAnimacion(tipo: any) {
    if (tipo) {
      return this.estadosAnimacion[tipo];
    }
  }

  getEntoronoAnimacion(tipo: any) {
    if (tipo) {
      return this.entoronoAnimacion[tipo];
    }
  }


  async redireccionarInterface(tipo: string) {
   // console.log('Seguimiento -> Redireccionar por ID tipo: ', tipo);
    switch (tipo) {
      case 'redatwater':
        this.navCtrl?.navigateRoot(['/redatwater']);
        break;

      case 'redatwater-usuario':
        this.navCtrl?.navigateRoot(['/redatwater-usuario']);
        break;

      case 'redatwater-cliente':
        this.navCtrl?.navigateRoot(['/redatwater-cliente']);
        break;

      default:
        this.navCtrl?.navigateRoot(['/logout']);
        break;

    }
  }

  async enlaceSugerido(enlace: any, titulo: string) {
    if (enlace) {
     // console.log('Seguimiento -> Alerta de redireccionamiento');
      const alert = await this.alertCtr.create({
        cssClass: 'my-custom-class',
        header: 'RED AT-WATER',
        message: 'El enlace sugerido <span class="text-success"> te llevará a nuevas experiencias:</span> <br> <span class="text-uppercase"><b>* ' + titulo + ' </b></span>',
        buttons: [
          {
            text: 'Cerrar ventana',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              console.log('Cerrar!');
            }
          }, {
            text: 'Abrir enlace',
            handler: () => {
              console.log('Abrir enlace sugerido!');

              this.abrirNavegador(enlace);

            }
          }
        ]
      });
      await alert.present();
    } else {
      console.log('Seguimiento de errores -> Parametros incompletos para enlace ', enlace);
    }
  }

  async abrirNavegador(enlace: any) {
    if (enlace) {
      Browser.open({ url: enlace }).then((getData) => {
       // console.log('App data Web Oficial -> ', getData);
      }).catch((err: any) => {
        console.log('Seguimiento de errores -> ', err);
      });
    } else {
      console.log('Seguimiento de errores -> ', enlace);
    }
  }


  async enlaceContacto(enlace: any, titulo: string) {
    if (enlace) {
     // console.log('Seguimiento -> Alerta de redireccionamiento para contacto');
      const alert = await this.alertCtr.create({
        cssClass: 'my-custom-class',
        header: 'RED AT-WATER',
        message: 'El enlace sugerido <span class="text-success"> te llevará a nuevas experiencias:</span> <br> <span class="text-uppercase"><b>* ' + titulo + ' </b></span>',
        buttons: [
          {
            text: 'Cerrar ventana',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              console.log('Cerrar!');
            }
          }, {
            text: 'Abrir enlace',
            handler: () => {
              console.log('Abrir enlace sugerido!');

              this.linkContacto(enlace);

            }
          }
        ]
      });
      await alert.present();
    } else {
      console.log('Seguimiento de errores -> Parametros incompletos para enlace ', enlace);
    }
  }

  linkContacto(url: string) {
    window.open(url, "_blank");
  }
  // Inicia el ciclo de ejecución
  public iniciarCicloAquabot(): void {
    console.log('¡Iniciando procesos automáticos!'); 

    if (this.enProceso) {
      console.log('Ya hay un proceso en curso. Espera...');
      return;
    }

    this.enProceso = true;
    this.ejecutarTareasAquabot();
  }

  // Ejecuta tareas disponibles
  private async ejecutarTareasAquabot(): Promise<void> {
    console.log('Verificando tareas...');

    try {
      const procesos = await this.obtenerProcesosAquabot();

      if (procesos.length) {
       // console.log('Procesos encontrados:', procesos);
        this.contadorReintentos = 0;
        await this.procesarTareas(procesos);
      } else {
        console.log('No hay tareas ahora.');
        this.reintentar();
      }
    } catch (error) {
      console.log('Error obteniendo procesos:', error);
      this.reintentar();
    } finally {
      this.enProceso = false;
    }
  }

  // Consulta procesos en el servidor
  private async obtenerProcesosAquabot(): Promise<any[]> {
    console.log('Consultando el servidor...');

    try {
      const dispositivo = await this.auth.loadAuthToken();
      if (!dispositivo) {
        console.log('Dispositivo no autenticado.');
      };

      const data: any = await this.redatwater.procesosAquabotChannel(dispositivo.id);
      if (data?.aquabot) {
       // console.log('Procesos recibidos:', data.aquabot);
        return [data.aquabot];
      }

      console.log('Sin procesos activos.');
      return [];
    } catch (error) {
      console.log('Error en la consulta de procesos:', error);
      return [];
    }
  }

  // Procesa las tareas según el tipo
  private async procesarTareas(procesos: any[]): Promise<void> {
    for (const proceso of procesos) {
      console.log(`Ejecutando: ${proceso.proceso_titulo}`);

      switch (proceso.aquabot_tipo) {
        case 'posicionamiento':
          await this.aquabotPosicionamiento(proceso);
          break;
        case 'ataque':
          await this.aquabotAtaque(proceso);
          break;
        default:
          console.log('Tipo de proceso desconocido:', proceso.aquabot_tipo);
      }
    }
    this.programarSiguiente();
  }

  // Simula posicionamiento de contenido
  public async aquabotPosicionamiento(proceso: any): Promise<void> {
   // console.log(`Posicionando contenido: ${proceso.proceso_weburl}`);
    const cant_repeticiones = proceso.proceso_totalprocesos;
    const dispositivo = await this.auth.loadAuthToken();
    if (!dispositivo) {
      console.log('Dispositivo no autenticado.');
    };

    const finalizarProceso = await this.redatwater.procesosFinalizarAquabotChannel(proceso.aquabot_id, dispositivo.id);

    const posicionamiento = await this.redatwater.aquabotPosicionamiento(proceso.proceso_titulo, proceso.proceso_weburl);
    if (posicionamiento) {
     // console.log('Seguimiento: ', posicionamiento);
    } else {
      console.log('Seguimiento de errores -> ', posicionamiento);
    }

  }

  // Simula ataque
  public async aquabotAtaque(proceso: any): Promise<void> {
   // console.log(`Ejecutando ataque en: ${proceso.proceso_weburl}`);

  }


  // Reintenta en caso de fallos o falta de procesos
  private reintentar(): void {
    if (this.contadorReintentos < this.maxReintentos) {
      this.contadorReintentos++;
     // console.log(`Reintentando en ${this.intervaloReintento / 1000}s... (${this.contadorReintentos}/${this.maxReintentos})`);
      this.programarSiguiente();
    } else {
      console.log('Máximo de reintentos alcanzado. Deteniendo.');
    }
  }

  // Programa la siguiente ejecución
  private programarSiguiente(): void {
    setTimeout(() => {
      this.iniciarCicloAquabot();
    }, this.intervaloReintento);
  }


}